import React from "react";

import { Link, animateScroll as scroll } from "react-scroll";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import Container from "react-bootstrap/Container";
import Image from 'react-bootstrap/Image'

const Header = () => {
  const scrollTo = id => e => {
    e.preventDefault();
    console.log("id", id);
    scroll.scrollTo({
      duration: 1500,
      delay: 100,
      smooth: "easeInOutQuint",
      containerId: id
    });
  };

  return (
    <header>
      
      <Navbar bg="none" expand="lg" fixed="top">
      <div style={{color:'red',fontWeight:500, marginLeft:100}}>
            TITAN LABORATORY
            </div>
        <Container>
          <Navbar.Brand
            href="#home"
            onClick={scrollTo("home")}
            aria-label="Logo"
          >
            {/* <div style={{color:'white',fontWeight:500}}>
            TITAN LABORATORY
            </div> */}
            {/* <div>
            <Image src={require ("../assets/img/vishal.JPG")} width='136px' height='92px'/>
            </div> */}
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav">
            <span />
            <span />
            <span />
          </Navbar.Toggle>
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav>
              <Link
                href="#"
                className="nav-link"
                activeClass="active"
                to="home"
                spy={true}
                smooth={true}
                offset={0}
                duration={400}
              >
                HOME
              </Link>
              <Link
                href="#"
                className="nav-link"
                activeClass="active"
                to="research"
                spy={true}
                smooth={true}
                offset={0}
                duration={400}
              >
                RESEARCH
              </Link>
              <Link
                href="#"
                className="nav-link"
                activeClass="active"
                to="gradstudents"
                spy={true}
                smooth={true}
                offset={0}
                duration={400}
              >
                TEAM
              </Link>
              <Link
                href="#"
                className="nav-link"
                activeClass="active"
                to="teaching"
                spy={true}
                smooth={true}
                offset={0}
                duration={400}
              >
                TEACHING
              </Link>
              
              <Link
                href="#"
                className="nav-link"
                activeClass="active"
                to="news"
                spy={true}
                smooth={true}
                offset={0}
                duration={400}
              >
                NEWS
              </Link>
              {/* <Link
                href="#"
                className="nav-link"
                activeClass="active"
                to="contact"
                spy={true}
                smooth={true}
                offset={0}
                duration={400}
              >
                Contact
              </Link> */}
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </header>
  );
};

export default Header;
